import React from 'react'
import { useTranslation } from 'react-i18next'
import {Form} from 'antd'
import {observer} from 'mobx-react'
import {Description, ManagerTip, Modal, ModalFormFooter} from '@/components'
import {LoadingState} from '@/types'
import {GetPINModalProps} from './props'

export const GetPINModal: React.FC<GetPINModalProps> = observer((
    {open, onCancel, onGetPINClick, pinData, loadingState}
) => {
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const formId = 'pin-input'

    const onFinish = async (values) => {
        await form.validateFields()
        // return onGetCVVClick(Object.entries(values).map(([_, value]) => value).join(''))
    }

    const PINDescriptions = pinData && [
        {
            label: t('GetPINModal.pinCode'),
            value: pinData.data.pin
        }
    ]

    return (
        <Modal
            open={open}
            title={t('GetPINModal.getPIN')}
            onCancel={onCancel}
            footer={<ModalFormFooter
                formId={formId}
                onCancel={onCancel}
                cancelText={t('GetPINModal.cancel')}
                okText={pinData ? t('GetPINModal.gotIt') : t('GetPINModal.getPIN')}
                onOk={pinData ? onCancel : onGetPINClick}
                confirmLoading={loadingState === LoadingState.LOADING}
            />}
        >
            <ManagerTip text={t('GetPINModal.seeYourPINAndRemember')}/>
            {/*<Form*/}
            {/*    form={form}*/}
            {/*    id={formId}*/}
            {/*    onFinish={onFinish}*/}
            {/*>*/}
            {/*    <PinInput form={form} length={6} formId={formId}/>*/}
            {/*</Form>*/}
            {pinData ? <Description dataSource={PINDescriptions}/> : null}
        </Modal>
    )
})
